export default {
    system: {
        main: 'Startseite',
        resident_portal: 'Wohnheimportal',
        tenant_portal: 'Mieterportal',
        dorm: 'Wohnheim',
        resident: 'Bewohner',
        tutor: 'TutorIn | TutorInnen',
        profile: 'Profil | Profile',
        account: 'Account',
        logout: 'Abmelden',
        login: 'Anmelden',
        username: 'Benutzername',
        new_username: 'Neuer Benutzername',
        password: 'Passwort',
        lastname: 'Nachname',
        firstname: 'Vorname',
        name: 'Name',
        phone: 'Telefon',
        house: 'Haus',
        room: 'Zimmer',
        email: 'E-Mail-Adresse',
        change_password: 'Passwort ändern',
        old_password: 'Altes Passwort',
        confirm_password: 'Neues Passwort bestätigen',
        new_password: 'Neues Passwort',
        set_new_password: 'Neues Passwort setzten',
        provided_by_stuwe: 'Daten durch das Studierendenwerk bereitgestellt',
        forgot_pw: 'Nutzername/Passwort vergessen',
        request_pw_reset: 'Passwort zurücksetzen',
        pw_reset_with_token: 'Passowrt (neu) setzten',
        email_updated: 'E-Mail-Adresse aktualisiert.',
        save: 'Speichern',
        manage_2fa: '2-Faktor-Authentifizierung verwalten',
        password_reset_instructions: 'Wir haben Dir eine E-Mail mit weiteren Instruktionen geschickt. Bitte überprüfe Deine Inbox.',
        tutors_in_dorm: 'TutorInnen im Wohnheim',
        wifi_password: 'Persönliches Wi-Fi-Passwort',
        common_rooms: 'Gemeinschaftsräume',
        common_rooms_in_dorm: 'Gemeinschaftsräume im Wohnheim',
        register: 'Registrieren',
        tutor_responsible: 'Zuständige TutorInnen',
        request_access: 'Zugang benatragen',
        active: 'Aktiv',
        discharge: 'Entlasten',
        delete_assignment: 'Zuweisung löschen',
        assign: 'Zuweisen',
        assignment: 'Zuweisung',
        cancel: 'Abbrechen',
        actions: 'Aktionen',
        label: 'Bezeichnung',
        card_id: 'Kartennummer',
        date_added: 'Hinzugefügt am',
        cards: 'Zugangskarten',
        imprint: 'Impressum',
        privacy_policy: "Datenschutz",
        semester_id: "Semester ID",
        semester_start: "Semester Start",
        semester_delete: "Semester Löschen",
        winter_semester: "Wintersemester {year}",
        summer_semester: "Sommersemester {year}",
        activate_semester: "Semester aktivieren",
        manage: "Verwalten",
        read_more: 'Weiterlesen',
        wifi: 'WLAN',
        faq: 'Häufige Fragen',
        discharged: 'Entlastet',
        tenant_name_or_room_number: 'Bewohnername oder Zimmernummer',
        finish_assignment: 'Zuweisung abschließen',
        manage_common_room: 'Gemeinschaftsraum verwalten',
        add_card: 'Karte hinzufügen',
        lock_card: 'Karte sperren',
        unlock_card: 'Karte entsperren',
        card_locked: 'Karte gesperrt',
        internet_access: 'Internetzugang',
        generate_token_link: 'Aktivierungs-/ Passwortlink erzeugen',
        generate_activation: 'Aktivierungslink erzeugen',
        semester_admin: 'Semesteradministration',
        tutor_admin: 'Tutoren Verwalten',
        admin_tutors: 'Admin Tutoren',
        null: '',
        mpsk: 'SW-KA-IoT',
        mac: "MAC Addresse",
        delete_device: "Gerät Löschen",
        close: "Schließen",
        toggle_pw: "Passwortanzeige",
        tutor_list_for: "Tutorenliste für das",
        tutor_type: "Typ",
        tutor_name: "Name",
        tutor_room: "Zimmer",
        tutor_mail: "E-Mail",
        tutor_phone: "Telefon",
        generate_pdf: "PDF erzeugen",
        amount: "Anzahl",
        amt_new: "Neues Amt",
        amt_edit: "Amt bearbeiten",
        amt_delete: "Amt löschen",
        amt_label: "Amtsname",
        amt_label_internal: "Interner Amtsname",
        amt_sorting_order: "Listenplatz",
        amt_wikom: "Wirtschaftskommission",
        amt_can_modify_tutors: "Tutorbearbeitung",
        amt_community_manager: "Community Manager",
        update_changes: "Änderungen speichern"
    },
    messages: {
        password_updated: 'Passwort aktualisiert.'
    },
    errors: {
        password_must_match: 'Passwörter stimmen nicht überein.',
        password_must_not_empty: 'Passwort darf nicht leer sein.',
        not_found: 'Angefragte Ressource nicht gefunden.',
        permission_denied: 'Zugriff verweigert/keine ausreichenden Rechte.',
        invalid_username: 'Ungültiger Nutzername. Erlaubte Zeichen sind a-z, 0-9, _, -. Keine Leerzeichen, nur kleine Buchstaben.',
        no_resident_for_user: 'Nutzer ist keinem Bewohner zugeordnet.',
        invalid_token: 'Token ungültig.',
        username_is_not_set: 'Nutzername noch nicht gesetzt.',
        old_password_wrong: 'Aktuelles Passowrt nicht korrekt.',
        unique_violation: 'Datensatz bereits vorhanden!',
        invalid_room: 'Ungültiger Raum',
        user_no_modify_rights: 'Bearbeiten ist nicht erlaubt',
        may_not_edit_semester_in_past: "Vergangene Semester dürfen nicht bearbeitet werden",
        user_no_rights_on_target: "Sie haben keine Rechte auf diesem Ziel",
        server_error: "Server Fehler",
        tenant_in_wrong_dorm: "Bewohner ist im falschen Wohnheim",
        invalid_profile: "Ungültiges Profil",
        invalid_card: "Ungültige Karte",
        invalid_user: "Ungültiger Nutzer",
        invalid_sensor: "Ungültiger Sensor",
        invalid_actuator: "Ungültiger Aktor",
        invalid_card_user_locked: "Ungültige Karte - Nutzerkonto ist gesperrt",
        invalid_card_no_rights: "Ungültige Karte - es Fehlen die Rechte.",
        semester_advance_non_monotonic: 'Semester vor dem aktuellen können nicht wieder aktiviert werden.',
        invalid_login: 'Ungültige Anmeldedaten',
        no_change: 'Es wurde keine Änderung vorgenommen.',
        invalid_psk: 'Ungültiges Gerätekennwort.',
        no_date_selected: 'Kein Datum ausgewählt.'
    }
}
